export function isEvoError(e: unknown): e is { error_code: string } {
  return e !== null && typeof e === "object" && "error_code" in e;
}
